import { ImageSlot, ImageTemplate } from '@/models/imageSlot'

const imageTemplateRegistry: Record<string, ImageTemplate> = {
  // Add your template configurations here
  // Example:
  // 'template-1': {
  //   slots: [
  //     { top: 10, left: 10, width: 30, height: 40, rotation: 5 },
  //     { top: 10, left: 50, width: 30, height: 40, rotation: -5 },
  //   ],
  //   mask: '<svg>...</svg>'
  // },
  abzug: {
    slots: [
      { top: 29.2, left: 12, width: 72, height: 48, rotation: -5 },
    ],
  },
  'photo-wood-stand': {
    slots: [
      {
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        rotation: 0,
        // Using the 4 corners you provided for perspective placement
        corners: {
          topLeft: [314, 347],
          topRight: [751, 365],
          bottomRight: [701, 787],
          bottomLeft: [253, 763]
        }
      },
    ],
    // Mask positioned at bottom of the 1000x1000 space
    mask: `<path d="M289.041,758.182L314.503,747.069L640.633,762.511L640.71,791.02L287.797,791.02L289.041,758.182Z" style="fill:rgb(235,235,235);"/>`
  },
  'photo-wood-stand-2': {
    slots: [
      {
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        rotation: 0,
        corners: {
          topLeft: [543, 602],
          topRight: [739, 611],
          bottomRight: [717, 800],
          bottomLeft: [516, 788]
        }
      },
    ],
    mask: `<path d="M214.681,748.602L214.354,738.113L246.942,722.852L670.766,743.714L670.745,773.6L214.681,748.602Z" style="fill:rgb(235,235,235);"/>`
  },
  'abzug-4x-square': {
    slots: [
      { top: 16, left: 17, width: 28, height: 28, rotation: 0 },
      { top: 16, left: 55, width: 28, height: 28, rotation: 0 },
      { top: 54, left: 17, width: 28, height: 28, rotation: 0 },
      { top: 54, left: 55, width: 28, height: 28, rotation: 0 },
    ],
  },
  'photo-stand-up-13x18': {
    slots: [
      {
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        rotation: 0,
        corners: {
          topLeft: [280, 179],
          topRight: [693, 188],
          bottomRight: [742, 794],
          bottomLeft: [318, 813]
        }
      },
    ],
    mask: '<path d="M1000,0L1000,1000L0,1000L0,0L1000,0ZM694.441,202.83C693.66,193.075 685.442,184.974 676.85,184.851L293.859,179.374C284.75,179.244 277.26,187.507 277.921,197.707L316.444,792.997C317.125,803.512 325.872,811.7 335.142,811.203L724.983,790.27C733.683,789.803 740.775,781.202 739.968,771.124L694.441,202.83Z" style="fill:rgb(235,235,235);"/>',
  },
  'photo-stand-up-18x13': {
    slots: [
      {
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        rotation: 0,
        corners: {
          topLeft: [165, 285],
          topRight: [848, 280],
          bottomRight: [883, 786],
          bottomLeft: [191, 818]
        }
      },
    ],
    mask: '<path d="M1000,0L1000,1000L0,1000L0,0L1000,0ZM848.165,294.325C847.559,286.365 840.406,279.409 832.344,279.472L179.97,284.566C171.258,284.634 164.585,292.154 165.02,300.511L191.134,802.304C191.581,810.89 199.181,818.153 208.007,817.714L870.525,784.748C878.708,784.34 884.879,776.833 884.26,768.694L848.165,294.325Z" style="fill:rgb(235,235,235);"/>',
  },
  'photo-stand-up-15x15': {
    slots: [
      {
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        rotation: 0,
        corners: {
          topLeft: [240, 253],
          topRight: [753, 253],
          bottomRight: [810, 786],
          bottomLeft: [284, 812]
        }
      },
    ],
    mask: '<path d="M1000,0L1000,1000L0,1000L0,0L1000,0ZM753.329,264.289C752.68,258.201 748.313,253.834 744.453,253.833L248.254,253.666C244.187,253.665 240.355,258.194 240.87,264.631L283.813,800.979C284.346,807.634 289.002,812.145 293.186,811.934L800.937,786.304C804.835,786.107 808.397,781.44 807.719,775.073L753.329,264.289Z" style="fill:rgb(235,235,235);"/>',
  },
  'photobook': {
    slots: [
      {
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        rotation: 0,
        corners: {
          topLeft: [240, 253],
          topRight: [753, 253],
          bottomRight: [810, 786],
          bottomLeft: [284, 812]
        },
      },
    ],
    mask: '<path d="M1000,0L1000,1000L0,1000L0,0L1000,0ZM692.788,326.031C692.788,326.031 456.92,318.506 261.484,295.688L263.2,736.382C263.2,736.382 457.11,769.118 701.436,791.655L692.788,326.031Z" style="fill:rgb(235,235,235);"/>'
  },
}

export function getImageTemplate(templateId: string | null | undefined): ImageTemplate | null {
  if (!templateId) return null
  return imageTemplateRegistry[templateId] || null
}

// Backward compatibility function
export function getImageSlots(templateId: string | null | undefined): ImageSlot[] | null {
  const template = getImageTemplate(templateId)
  return template ? template.slots : null
}
